module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-13.e2805937.jpg";